import Backend from "shared/lib/Backend";
import { v4 as uuid } from 'uuid';

export default id => async dispatch => {
  const body = JSON.stringify({ entity: { id } });
  const response = await Backend.requestJson(
    `${window.location.pathname}/collections`,
    { body },
    "DELETE"
  );

  dispatch({
    type: "COLLECTIONS/ENTITY/DELETE",
    payload: { id: id }
  });
};
